import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Flex } from "antd";
import { ROUTES } from "../../config/routes";
import {
  SpecimenForm,
  SpecimenHeader,
  SpecimenImage,
  BackButton,
  LoadingView,
  NotFoundView,
  TrapsiteContainer,
} from "../../components/Specimen";
import { useSpecimenData } from "./useSpecimenData";
import { useSpecimenSubmit } from "./useSpecimenSubmit";
import "./index.css";

const SpecimenDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const {
    isMeshRoute,
    isLoading,
    item,
    displayTitle,
    catalogItem,
    handleDownload,
    trapSite,
    deviceId,
  } = useSpecimenData(id);

  const { handleSubmit, isSubmitting } = useSpecimenSubmit(id ?? "", item);

  const handleGoBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(ROUTES.image_catalog);
    }
  };

  if (isLoading) return <LoadingView />;

  if (!id || !item) {
    return <NotFoundView isMeshRoute={isMeshRoute} onGoBack={handleGoBack} />;
  }

  return (
    <div className="p-6  min-h-full ">
      <Flex vertical gap="large">
        {/* Navigation */}
        <Flex align="center" gap="small">
          <BackButton onClick={handleGoBack} />
        </Flex>

        <div className="rounded-xl shadow-sm overflow-hidden bg-white p-6 border border-[#0C4A6E]">
          <Flex vertical gap="8px">
            <SpecimenHeader
              id={id}
              displayTitle={displayTitle}
              isMeshRoute={isMeshRoute}
              catalogItem={catalogItem}
              onDownload={handleDownload}
            />

            {/* Main Image View */}
            <SpecimenImage imgUrl={item.img} />

            {/* Grid for Map and Form */}
            <Flex gap="large" className="mt-4!">
              <TrapsiteContainer trapSite={trapSite} deviceId={deviceId} />

              {/* Form */}
              <SpecimenForm
                item={item}
                id={id}
                isMeshRoute={isMeshRoute}
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
              />
            </Flex>
          </Flex>
        </div>
      </Flex>
    </div>
  );
};

export default SpecimenDetail;
